<template>
  <div id="header" :class="headerClass">
    <div class="left">
      <Google />
    </div>
    <div class="center">
      <a href="/">
        <p class="title">
          Matsuo
          <br />Portofolio
        </p>
      </a>
    </div>
    <div class="right">
      <Menu />
    </div>
  </div>
</template>

<script>
export default {
  name: "Header",
  props: {
    headerClass: {
      type: String,
      default: ""
    }
  }
};
</script>

<style scoped>
#header {
  padding: 5px;
  height: 13%;
  display: -webkit-flex;
  display: flex;
  margin: 0;
}

#header a {
  font-weight: bold;
  color: #2c3e50;
}

#header a.router-link-exact-active {
  color: #42b983;
}
div.left {
  width: 25%;
  text-align: left;
}
div.center {
  display: table-cell;
  height: 100%;
  width: 50%;
}
div.right {
  width: 25%;
  text-align: right;
}
p.title {
  font-size: 20px;
  font-weight: bolder;
  text-decoration: none;
}
p.title:hover {
  cursor: pointer;
}
a:link {
  text-decoration: none;
}
a:visited {
  color: #2c3e50;
}
</style>
